import React from 'react';
import { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react'; // Import QRCode component
import { REACT_APP_LIGHTNING_ADDRESS } from '../../utils/constant';
import BlinkAPI from '../../components/BlinkAPI';
import PayPal from '../../components/PayPal';
import { useTranslation } from 'react-i18next'; // Import useTranslation



// Replace this with your project's actual Blink Lightning Address

function Spendings() {
  const [payPalLoading, setPayPalLoading] = useState(true);
  const [btcAmount, setBtcAmount] = useState(''); // User can input an amount, e.g., in sats
  const [showLightningInfo, setShowLightningInfo] = useState(false);

  const { t, i18n } = useTranslation(); // Initialize useTranslation

  const handleAmountChange = (e) => {
    setBtcAmount(e.target.value);
  };

  const toggleLightningInfo = () => {
    setShowLightningInfo(!showLightningInfo);
  };

  return (
    <div className="spendings-container">
      <h1>{t("spendings.header.overall")}</h1>
      <div className="donation-flex">
        <div className="donation-box">
          <BlinkAPI />
        </div>
        <div className="donation-box">
          <PayPal />
        </div>
      </div>
    </div>  
  );
}

export default Spendings;